/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { Timelock, TimelockInterface } from "../Timelock";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "_admin",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_buffer",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "_tokenManager",
            type: "address",
          },
          {
            internalType: "address",
            name: "_mintReceiver",
            type: "address",
          },
          {
            internalType: "address",
            name: "_mlpManager",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "_maxTokenSupply",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_marginFeeBasisPoints",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "_maxMarginFeeBasisPoints",
            type: "uint256",
          },
        ],
        internalType: "struct Timelock.initParams",
        name: "params",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "ClearAction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "SignalApprove",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "SignalMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "SignalPendingAction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SignalRedeemUsdg",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "gov",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "SignalSetGov",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "handler",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isActive",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "SignalSetHandler",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "priceFeed",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "SignalSetPriceFeed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenDecimals",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenWeight",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minProfitBps",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxUsdgAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isStable",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isShortable",
        type: "bool",
      },
    ],
    name: "SignalVaultSetTokenConfig",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "action",
        type: "bytes32",
      },
    ],
    name: "SignalWithdrawToken",
    type: "event",
  },
  {
    inputs: [],
    name: "MAX_BUFFER",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_FUNDING_RATE_FACTOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_LEVERAGE_VALIDATION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRICE_PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "admin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vester",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "batchSetBonusRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "batchWithdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "buffer",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_action",
        type: "bytes32",
      },
    ],
    name: "cancelAction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
    ],
    name: "disableLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
    ],
    name: "enableLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_referralStorage",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_code",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_newAccount",
        type: "address",
      },
    ],
    name: "govSetCodeOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isHandler",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isKeeper",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marginFeeBasisPoints",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxMarginFeeBasisPoints",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxTokenSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintReceiver",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mlpManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "pendingActions",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "processMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "redeemUsdg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "removeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_buffer",
        type: "uint256",
      },
    ],
    name: "setBuffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_handler",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setContractHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_admin",
        type: "address",
      },
    ],
    name: "setExternalAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_taxBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_stableTaxBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_mintBurnFeeBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_swapFeeBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_stableSwapFeeBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_marginFeeBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_liquidationFeeUsd",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minProfitTime",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_hasDynamicFees",
        type: "bool",
      },
    ],
    name: "setFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_fundingInterval",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_fundingRateFactor",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_stableFundingRateFactor",
        type: "uint256",
      },
    ],
    name: "setFundingRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_handler",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_inPrivateLiquidationMode",
        type: "bool",
      },
    ],
    name: "setInPrivateLiquidationMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_inPrivateTransferMode",
        type: "bool",
      },
    ],
    name: "setInPrivateTransferMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isLeverageEnabled",
        type: "bool",
      },
    ],
    name: "setIsLeverageEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isSwapEnabled",
        type: "bool",
      },
    ],
    name: "setIsSwapEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_keeper",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setKeeper",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_liquidator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setLiquidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_marginFeeBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxMarginFeeBasisPoints",
        type: "uint256",
      },
    ],
    name: "setMarginFeeBasisPoints",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxGasPrice",
        type: "uint256",
      },
    ],
    name: "setMaxGasPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "setMaxGlobalShortSize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_maxLeverage",
        type: "uint256",
      },
    ],
    name: "setMaxLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceFeed",
        type: "address",
      },
    ],
    name: "setPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_referralStorage",
        type: "address",
      },
      {
        internalType: "address",
        name: "_referrer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tierId",
        type: "uint256",
      },
    ],
    name: "setReferrerTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_shouldToggleIsLeverageEnabled",
        type: "bool",
      },
    ],
    name: "setShouldToggleIsLeverageEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_taxBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_stableTaxBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_mintBurnFeeBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_swapFeeBasisPoints",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_stableSwapFeeBasisPoints",
        type: "uint256",
      },
    ],
    name: "setSwapFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_referralStorage",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tierId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_totalRebate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_discountShare",
        type: "uint256",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenWeight",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minProfitBps",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxUsdgAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_bufferAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_usdgAmount",
        type: "uint256",
      },
    ],
    name: "setTokenConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_usdgAmounts",
        type: "uint256[]",
      },
    ],
    name: "setUsdgAmounts",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "contract IVaultUtils",
        name: "_vaultUtils",
        type: "address",
      },
    ],
    name: "setVaultUtils",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "shouldToggleIsLeverageEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "signalApprove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "signalMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "signalRedeemUsdg",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "signalSetGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_handler",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "signalSetHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_priceFeed",
        type: "address",
      },
    ],
    name: "signalSetPriceFeed",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenDecimals",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tokenWeight",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minProfitBps",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxUsdgAmount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isStable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_isShortable",
        type: "bool",
      },
    ],
    name: "signalVaultSetTokenConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "signalWithdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenManager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "transferIn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "usdgAmount",
        type: "uint256",
      },
    ],
    name: "updateUsdgSupply",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenDecimals",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tokenWeight",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minProfitBps",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxUsdgAmount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_isStable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "_isShortable",
        type: "bool",
      },
    ],
    name: "vaultSetTokenConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "withdrawFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TimelockConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TimelockConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Timelock__factory extends ContractFactory {
  constructor(...args: TimelockConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    params: Timelock.InitParamsStruct,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(params, overrides || {});
  }
  override deploy(
    params: Timelock.InitParamsStruct,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(params, overrides || {}) as Promise<
      Timelock & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Timelock__factory {
    return super.connect(runner) as Timelock__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TimelockInterface {
    return new Interface(_abi) as TimelockInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Timelock {
    return new Contract(address, _abi, runner) as unknown as Timelock;
  }
}
